import { useState } from 'react';
import Configuracion from '../Configuracion/Configuracion';


// export default function Navbar({ logout }) {
//     return (
//         <div className="flex justify-end items-center bg-black">
//             <nav className="p-1 w-full lg:w-60 ">
//                 <button onClick={logout} className=" border rounded-full  py-1.5 lg:py-0.5 px-4 bg-red-500 flex justify-center items-center w-full text-xl lg:text-md  text-white font-semibold cursor-pointer">SALIR</button>
//             </nav>

//         </div>
//     )

   
// }


export default function Navbar({ logout, vistaModal, cambiarVistaModal, tema, cambiarTema }) {
    const [mostrarConfig, setMostrarConfig] = useState(false);

    return (
        <>
        <header className="sticky top-0 z-50 w-full border-b border-slate-200/80 bg-white/90 pt-[env(safe-area-inset-top)] backdrop-blur-md supports-[backdrop-filter]:bg-white/75 dark:border-slate-800 dark:bg-slate-900/90 dark:supports-[backdrop-filter]:bg-slate-900/75">
            <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
                <div className="flex h-14 items-center justify-between">

                    {/* Marca */}
                    <div className="flex min-w-0 items-center gap-2.5">
                        <img
                            src={`${process.env.PUBLIC_URL}/logo.png`}
                            alt=""
                            className="h-9 w-9 shrink-0 object-contain lg:h-8 lg:w-8"
                        />
                        <div className="min-w-0 leading-tight">
                            <p className="truncate text-[15px] font-bold tracking-tight text-slate-900 dark:text-white lg:text-sm">
                                Chaboux <span className="font-medium text-brand-600 dark:text-brand-400">Cluster</span>
                            </p>
                            <p className="truncate text-xs text-slate-500 dark:text-slate-400 lg:text-[11px]">Lista de precios</p>
                        </div>
                    </div>

                    {/* Acciones */}
                    <nav className="flex shrink-0 items-center gap-2">
                        <button
                            onClick={() => setMostrarConfig(true)}
                            aria-label="Configuración"
                            title="Configuración"
                            className="flex h-10 w-10 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-600 shadow-sm transition hover:bg-slate-50 hover:text-slate-900 focus:outline-none focus-visible:ring-4 focus-visible:ring-brand-500/20 active:scale-[0.97] dark:border-slate-700 dark:bg-slate-800 dark:text-slate-300 dark:hover:bg-slate-700 dark:hover:text-white lg:h-8 lg:w-8 lg:rounded-lg"
                        >
                            <svg className="h-5 w-5 lg:h-4 lg:w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                            </svg>
                        </button>
                        <button
                            onClick={logout}
                            className="inline-flex h-10 items-center gap-2 rounded-xl border border-slate-200 bg-white px-3.5 text-sm font-medium text-slate-700 shadow-sm transition hover:border-red-200 hover:bg-red-50 hover:text-red-600 focus:outline-none focus-visible:ring-4 focus-visible:ring-red-500/20 active:scale-[0.97] dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200 dark:hover:border-red-900 dark:hover:bg-red-950 dark:hover:text-red-400 lg:h-8 lg:gap-1.5 lg:rounded-lg lg:px-2.5 lg:text-xs"
                        >
                            <svg className="h-[18px] w-[18px] lg:h-4 lg:w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                            </svg>
                            Salir
                        </button>
                    </nav>

                </div>
            </div>
        </header>

        {mostrarConfig && (
            <Configuracion
                vistaModal={vistaModal}
                cambiarVistaModal={cambiarVistaModal}
                tema={tema}
                cambiarTema={cambiarTema}
                cerrar={() => setMostrarConfig(false)}
            />
        )}
        </>
    );
}
